import React from 'react';
import { func, node, string, } from 'prop-types';

import s from './SingleActionCard.css';

function SingleActionCard({ actionCallback, actionLabel, content, id, title, }) {

  const handleActionCallback = (event) => {
    if (actionCallback) {
      actionCallback(event);
    }
  };

  return (
    <div className={s.component} id={id}>
      <h1 className={s.title} id={`${id}__title`}>{title}</h1>
      <p className={s.content} id={`${id}__content`}>{content}</p>
      <button
        className={s.btn}
        id={`${id}__action`}
        onClick={handleActionCallback}
      >
        {actionLabel}
      </button>
    </div>
  );
}

SingleActionCard.propTypes = {
  actionCallback: func,
  actionLabel: node,
  content: node,
  id: string.isRequired,
  title: node,
};

export default SingleActionCard;


// WEBPACK FOOTER //
// ./src/components/SingleActionCard/SingleActionCard.js